import { Swiper, SwiperSlide } from "swiper/react";
import { useEffect, useState, useRef } from "react";
import "swiper/css";
import "./index.scss";

function SliderComponent({
  styleSwiper,
  styleSwiperSlide,
  data,
  defaultSlide = 0,
  maxWidth,
  maxFont,
  additionalCssClass,
  slideReverseAction = () => {},
  onActiveSlideChange = () => {},
  onClickSlide = () => {},
}) {


  const swiperRef = useRef(null);
  const [activeSlide, setActiveSlide] = useState(defaultSlide);

  const SetSwiper = (e) => {
    swiperRef.current = e;
  };

  const handleChangeSlide = (index) => {
    setActiveSlide(index.activeIndex)
    onActiveSlideChange(data[index.activeIndex].actionValue);
  }

   useEffect(() => {
    swiperRef?.current.slideTo(defaultSlide);
  }, [defaultSlide, data]);

  const handleTouchEnd = (event) => {
    let dx = event.touches.currentX - event.touches.startX;
    let dy = event.touches.currentY - event.touches.startY;
    if (dy < -5 && Math.abs(dx) > Math.abs(dy)) {
      let item = data[defaultSlide];
      onClickSlide(item.actionValue);
    }
    if (dy > 5 && Math.abs(dx) < Math.abs(dy)) {
      slideReverseAction(0);
    }
  };

  const fontSizeSwiper = (item) => {
    if (window.screen.width >= 1100) {
      return Math.min(maxFont, (maxWidth / (item.text?.length * 20)) * 23);
    }
    if (window.screen.width >= 768) {
      return Math.min(maxFont, (maxWidth / (item.text?.length * 20)) * 21);
    }
    if (window.screen.width >= 480) {
      return Math.min(maxFont, (maxWidth / (item.text?.length * 20)) * 20);
    }
    if (window.screen.width < 480) {
      return Math.min(maxFont, (maxWidth / (item.text?.length * 20)) * 15);
    }
    if (window.screen.width < 384) {
      return Math.min(maxFont, (maxWidth / (item.text?.length * 20)) * 12);
    }
  };

  return (
      <Swiper
        className="patent-swiper"
        style={styleSwiper}
        onSwiper={SetSwiper}
        spaceBetween={0}
        slidesPerView={"auto"}
        centeredSlides={true}
        onActiveIndexChange={handleChangeSlide}
        onTouchEnd={handleTouchEnd}
      >
        {data?.map((item, index) => (
          <SwiperSlide
            key={index}
            className={`swiperSlider ${additionalCssClass} ${
              index === activeSlide ? "active" : "notActive"
            }`}
            style={{
              ...styleSwiperSlide,
              fontSize: `${fontSizeSwiper(item)}px`,
            }}
            onClick={() => onClickSlide(index)}
          >
            {item.text}
          </SwiperSlide>
        ))}
      </Swiper>
  );
}

export default SliderComponent;